export default __webpack_public_path__ + "static/media/expl-dissect_05_EN.8d83522e.png";